// extracted by mini-css-extract-plugin
export default {"principal":"Principal_principal__pgf-H"};